export enum Subdomain {
    // Domain 1
    CONTENT_KNOWLEDGE = '1a',
    STUDENT_KNOWLEDGE = '1b',
    SETTING_OUTCOMES = '1c',
    RESOURCE_KNOWLEDGE = '1d',
    COHERENT_INSTRUCTION = '1e',
    STUDENT_ASSESSMENT = '1f',

    // Domain 2
    ENVIRONMENT_OF_RESPECT = '2a',
    CULTURE_FOR_LEARNING = '2b',
    CLASSROOM_PROCEDURES = '2c',
    STUDENT_BEHAVIOUR = '2d',
    PHYCICAL_SPACE = '2e',

    // Domain 3
    COMMUNICATING_WITH_STUDENTS = '3a',
    QUESTIONING_TECHNIQUES = '3b',
    ENGAGING_STUDENTS = '3c',
    USING_ASSESSMENT = '3d',
    FLEXIBILITY = '3e',

    // Domain 4
    REFLECTING = '4a',
    ACCURATE_RECORDS = '4b',
    COMMUNICATING = '4c',
    PROFESSIONAL_COMMUNITY = '4d',
    GROWING = '4e',
    PROFESSIONALISM = '4f'
}